import { useEffect, useRef } from "react";
import {
  images,
  startAnimation,
  startTouchAnimation,
  isTouchDevice,
} from "../utils/startAnimation";

export function HomePage() {
  const trailSizeRef = useRef(60);

  useEffect(() => {
    const recalc = () => {
      const vw = window.innerWidth;
      if (vw > 1199) {
        trailSizeRef.current = ((vw - 260) / 12) * 2 + 20;
        return;
      } else if (vw > 600) {
        trailSizeRef.current = ((vw - 260) / 12) * 3 + 40;
      } else {
        trailSizeRef.current = ((vw - 75) / 4) * 2 + 15;
      }
    };
    recalc();
    window.addEventListener("resize", recalc);
    return () => window.removeEventListener("resize", recalc);
  }, []);

  useEffect(() => {
    if (isTouchDevice()) {
      return startTouchAnimation({
        containerId: "trail-container",
        images,
        getSize: () => trailSizeRef.current,
        lifetime: 1300,
        loopDuration: 13,
        spawnInterval: 180,
      });
    } else {
      return startAnimation({
        wrapperSelector: ".trail-block",
        containerId: "trail-container",
        images,
        getSize: () => trailSizeRef.current,
        throttle: 110,
        lifetime: 1000,
      });
    }
  }, []);

  return (
    <div className="home-hero grid-twelve-cols-lg grid-four-cols-sm">
      <div className="start-one-lg span-twelve-lg start-one-sm span-four-sm trail-block">
        <div id="trail-container" />
      </div>
    </div>
  );
}
